import { ICommunicationServices } from './communication.types'
import { http } from '@/shared/https'
import { Utilities as utils } from '@/shared/utilities'
import { AppConstants as _app } from "@/shared/app.constants";

export class CommunicationService implements ICommunicationServices {

    /** Project Info columns */
    projectInfoCols: Array<any> = [
        { text: "Grant Code", width: "200px", value: "GrantCode", sortable: true, show: true },
        { text: "Initiative", width: "200px", value: "Initiative", sortable: true,show: true },
        { text: "Grantee", width: "200px", value: "Grantee", sortable: true,show: true },
        { text: "Start Date", width: "150px", value: "StartDate", sortable: true, show: true, type: "date" },
        { text: "End Date", width: "150px", value: "EndDate", sortable: true, show: true, type: "date" },
        { text: "End Date(extended)", width: "150px", value: "ExtendedDate", sortable: true,show: true, type: "date" }
    ];

    /** SETUP columns */
    setupCols: Array<any> = [
        { text: "Program Officer", width: "200px", value: "ProgramOfficer", sortable: false,show: false },
        { text: "Emailed", width: "100px", value: "Emailed", sortable: false,show: false, type: "boolean" },
        { text: "Call", width: "100px", value: "Call", sortable: false,show: false, type: "boolean" }
    ];

    /** Contacts columns */
    contactsCols: Array<any> = [
        { text: "Project lead name", value: "projectLeadName", sortable: false,show: false },
        { text: "Project lead email", value: "projectLeadEmail", sortable: false,show: false },
        { text: "Communication lead name", value: "commLeadName", sortable: false,show: false },
        { text: "Communication lead email", value: "commLeadEmail", sortable: false,show: false },
    ];

    /** CHANNEL Columns */
    channelsCols: Array<any> = [
        { text: "Website", width: "200px", value: "websiteLink", sortable: false, show: false },
        { text: "Facebook", width: "200px", value: "facebookLink", sortable: false,show: false },
        { text: "Twitter", width: "200px", value: "twitterLink", sortable: false,show: false },
        { text: "Instagram", width: "200px", value: "instagramLink", sortable: false,show: false },
        { text: "News letter", width: "200px", value: "newsLetter", sortable: false,show: false }
    ];

    /** Following US Columns */
    followingUSCols: Array<any> = [
        { text: "Following us - Facebook", width: "200px", value: "followingusfb", sortable: false, show: false, type: "boolean" },
        { text: "Following us - Twitter", width: "200px", value: "followingustw", sortable: false, show: false, type: "boolean" },
        { text: "Following us - Instagram", width: "200px", value: "followingusin", sortable: false, show: false, type: "boolean" }
    ];

    /** Following THEM Columns */
    followingThemCols: Array<any> = [
        { text: "Following them - Facebook",width: "200px", value: "followingthemfb", sortable: false, show: false, type: "boolean" },
        { text: "Following them - Twitter", width: "200px", value: "followingthemtw", sortable: false, show: false, type: "boolean" },
        { text: "Following them - Instagram", width: "200px", value: "followingthemin", sortable: false, show: false, type: "boolean" }
    ];

    reportCols: Array<any> = [
        { text: 'Description', width: "30%", sortable: true, value: 'Description'  },
        {text: 'Story', width: "10%", sortable: true, value: 'StoryName'  },
        { text: 'Start date',  width: "20%", sortable: false, value: 'StartDate'  },
        { text: 'End date',  width: "20%", sortable: false, value: 'EndDate'  },
        { text: 'Status',  width: "28%", sortable: false, value: 'ReportStatus'  },
        { text: '',  width: "20px", sortable: false, value: 'Action'  }
    ];

    communicationDocCols: Array<any> = [
        { text: "Call",  width: "200px", value: "Call", sortable: false,show: true },
        { text: "Grant Code",  width: "100px", value: "GrantCode", sortable: true,show: true },
        { text: "Grant", value: "Grant", sortable: false, show: true},
        { text: "Organization", value: "Organization", sortable: true, show: true},
        { text: "Report", value: "Report", sortable: false, show: true},
        { text: "Description", value: "Title", sortable: false, show: false},
        { text: "Tag", value: "TagName", sortable: false, show: true},
        { text: "Uploaded Date", value: "CreatedDate", sortable: true, type: "date", show: true},
        { text: "File", value: "FileName", sortable: false, show: true }
    ];

    /** method to get list of grants with filter */
    getCommnicationList(params?: any): any {
        return http.get(`api/GrantCommunication/List?${params}`).then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            } else {
                throw(resp.message);
            }
        });
    }

    /** list the communication docs */
    getCommunicationDocs(filter: any) {

        return http.post("api/GrantCommunication/Docs/List", filter)
        .then((resp: any) => {

            if (resp.status >= 200 && resp.status < 300) {

                return resp.data;
            }
        });
    }


    /** Get the communication doc filter */
    getCommunicationDocsFilters() {
        return http.get("api/GrantCommunication/Docs/Filter")
        .then((resp: any) => {

            if (resp.status >= 200 && resp.status < 300) {

                return resp.data;
            }
        });
    }

    /** Get the communication doc filter */
    getCommunicationTrackerFilters() {
        return http.get("api/GrantCommunication/Tracker/Filter")
        .then((resp: any) => {

            if (resp.status >= 200 && resp.status < 300) {

                return resp.data;
            }
        });
    }

    /** list the communication tracker */
    getCommunicationTracker(filter: any) {

        return http.post("api/GrantCommunication/Tracker/List", filter)
        .then((resp: any) => {

            if (resp.status >= 200 && resp.status < 300) {

                var maxReportCnt = 1;

                // #. flatten the the data..
                var data = resp.data.reduce((arr: Array<any>, obj: any) => {
                    if(obj.TrackerData) {
                        var datum = obj.TrackerData;

                        // #. format sories as key value
                        if(datum.stories && datum.stories.length > 0) {

                            if(maxReportCnt < datum.stories.length) {
                                maxReportCnt = datum.stories.length;
                            }
                            
                            datum.stories.filter(x=>obj.Stories.includes(x.StepId)).forEach((story, index) => {
                                datum[`story_${index + 1}`] = story.EndDate;
                            })
                            
                            delete datum.stories;                            
                        }

                        // #. Merge the tracker data
                        Object.assign(datum, obj);
                        delete datum.TrackerData;

                        arr.push(datum);

                        return arr;
                    }
                }, []);

                // #. return the object
                return { data, maxReportCnt };

            } else {
                throw (resp.data);
            }
        });
    }

    /** list the communication tracker */
    getTrackerById(id: number) {
        return http.get(`api/GrantCommunication/Tracker/${id}`)
        .then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                throw (resp.data);
            }
        });
    }

    /** get the communication data */
    getCommunication(id: number): any {
        return http.get(`api/GrantCommunication/${id}`).then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            } else {
                throw(resp.message);
            }
        });
    }

    /** Start the communication */
    startCommunication(nextStepId: number, comm: any) {
        var data = utils.clone(comm);
        data.Steps = JSON.stringify(data.Steps);

        return http.put(`api/GrantCommunication/${comm.GrantCommunicationId}/Start/${nextStepId}`, data)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            } else {
                throw(resp.message);
            }
        })
    }

    /** Update the communcation */
    updateCommunication(comm: any): any {
        var data = utils.clone(comm);
        data.Steps = JSON.stringify(data.Steps);

        return http.put(`api/GrantCommunication/${comm.GrantCommunicationId}`, data)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            } else {
                throw(resp.message);
            }
        })
    }

    /** Return the report */
    returnReport(report: any): any {
        var param = utils.clone(report);
        param.ReportData = JSON.stringify(param.ReportData); 

        return http.put(`api/GrantCommunication/${report.GrantCommunicationId}/Report/${report.CommunicationReportId}/Return`, param)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            } else {
                throw(resp.message);
            }
        })
    }
    

    /** update the communication report */
    updateReport(report: any): any {
        var param = utils.clone(report);
        param.ReportData = JSON.stringify(param.ReportData);
        // report.ReportData = JSON.stringify(report.ReportData);

        return http.put(`api/GrantCommunication/${report.GrantCommunicationId}/Report/${report.CommunicationReportId}`, param)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            } else {
                throw(resp.message);
            }
        });
    }

    updateTracker(id: number, data: any) {
        return http.put(`api/GrantCommunication/${id}/Tracker`, data)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            } else {
                throw(resp.message);
            }
        })
    }

    /** submit the communication report */
    submitReport(report: any): any {
        var param = utils.clone(report);
        param.ReportData = JSON.stringify(param.ReportData);

        return http.put(`api/GrantCommunication/${report.GrantCommunicationId}/Report/${report.CommunicationReportId}/Submit`, param)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            } else {
                throw(resp.message);
            }
        });
    }

    /** submit the communication report */
    reSubmitReport(report: any): any {
        var param = utils.clone(report);
        param.ReportData = JSON.stringify(param.ReportData);

        return http.put(`api/GrantCommunication/${report.GrantCommunicationId}/Report/${report.CommunicationReportId}/ReSubmit`, param)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            } else {
                throw(resp.message);
            }
        });
    }

}